import {GenericModel} from "../../../generic.model";

export class PickUpModel extends GenericModel {
    //TODO ADD MISSING ARGUMENTS : dropOff: {keyArray: ["DABT71"], xRef: "L.DABT71"}
    public xRef: string;

    protected fromJson(json?: any): boolean {
        this.xRef = json.xRef ?? null;
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.xRef !== null;
    }
}